import { useClientTypeStore } from '@/store/clientTypes';

export const leadsOptions = {
    getClientTypes: async (query: string | Record<string, any> = '') => {
        const store = useClientTypeStore();
        await store.fetchClientTypes(query);
        return store.client_types;
      },
}